/* eslint-disable @typescript-eslint/no-require-imports */
import { ImageRequireSource } from 'react-native';
import { IllustrationKeyType } from 'shared/components/vxl/Illustration/Illustration';

export enum AccountIconType {
  Advance = 'ADVANCE',
  ChargeCard = 'CHARGE_CARD',
  Checking = 'CHECKING',
  LineOfCredit = 'LINE_OF_CREDIT',
  PayOverTime = 'PAY_OVER_TIME',
  Savings = 'SAVINGS',
  Unknown = 'UNKNOWN',
}

const illustrationKeyMap: Record<AccountIconType, IllustrationKeyType> = {
  [AccountIconType.Advance]: 'ADVANCE',
  [AccountIconType.ChargeCard]: 'BELIEVE',
  [AccountIconType.Checking]: 'CHECKING',
  [AccountIconType.LineOfCredit]: 'LINE_OF_CREDIT',
  [AccountIconType.PayOverTime]: 'PAY_OVER_TIME',
  [AccountIconType.Savings]: 'SAVING',
  [AccountIconType.Unknown]: 'PLACEHOLDER_A',
};

export const getIllustrationKey = (
  product: AccountIconType,
): IllustrationKeyType => {
  return illustrationKeyMap[product];
};

export const AccountIconIllustrationMap = {
  ADVANCE:
    require('assets/images/vxl/component/accountIcon/advance.png') as ImageRequireSource,
  BELIEVE:
    require('assets/images/vxl/component/accountIcon/believe.png') as ImageRequireSource,
  CHECKING:
    require('assets/images/vxl/component/accountIcon/checking.png') as ImageRequireSource,
  LINE_OF_CREDIT:
    require('assets/images/vxl/component/accountIcon/line-of-credit.png') as ImageRequireSource,
  PAY_OVER_TIME:
    require('assets/images/vxl/component/accountIcon/pay-over-time.png') as ImageRequireSource,
  SAVING:
    require('assets/images/vxl/component/accountIcon/saving.png') as ImageRequireSource,
} satisfies Record<string, ImageRequireSource>;
